/**
 * La base de personas del comercio (`/activa/emails/personas`): cada persona a la que le llegó algún mail, con lo que
 * hizo en todas las campañas juntas (y en cuáles está). La de una sola campaña está en su detalle.
 */

import { TablaPersonas } from "../components/TablaPersonas";

export default function PersonasEmailsPage() {
  return (
    <div className="space-y-5">
      <header>
        <h2 className="text-xl md:text-2xl font-bold text-slate-900 tracking-tight">Personas</h2>
        <p className="text-sm text-slate-500 mt-1">Todas las personas a las que les mandaste un mail, con lo que hicieron en todas las campañas</p>
      </header>
      <TablaPersonas />
    </div>
  );
}
